/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Outsideairtemperaturedefect3Inputs */



/**
* | output |
* | --- |
* | "Fresh air temperature sensor fault" |
*
* @param {Ahu_History_Key_Outsideairtemperaturedefect3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_outsideairtemperaturedefect3 = /** @type {((inputs?: Ahu_History_Key_Outsideairtemperaturedefect3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Outsideairtemperaturedefect3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Fresh air temperature sensor fault")
	return /** @type {LocalizedString} */ ("Défaut sonde température air neuf")
});
export { ahu_history_key_outsideairtemperaturedefect3 as "ahu_history_key_outsideAirTemperatureDefect" }